import { JetView, plugins } from 'webix-jet';

/**
 * Class representing the bet shop management view.
 * @extends JetView
 */
export default class betShopManagementView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service

        return {
            cols: [
                {
                    localId: 'inner:layout', // Unique identifier for the layout
                    rows: [
                        {
                            view: 'tabbar', // Tab bar component
                            localId: 'tabbar', // Unique identifier for the tab bar
                            id: 'addBetShop', // ID for the tab bar
                            height: 43, // Height of the tab bar
                            options: [], // Options for the tab bar (empty initially)
                            css: 'tittle', // CSS class for styling
                            template:
                                "<span style='font-weight:bold;padding:15px;display:inline-block;'>" +
                                _('Añadir punto de venta:') + // Localized label
                                '</span>',
                        },
                        { $subview: true }, // Placeholder for subviews
                    ],
                },
            ],
            elements: [
                { view: 'label', label: _('Puntos de Venta'), width: 150 }, // Label for the view
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use menu plugin with the tab bar
        this.on(
            this.app,
            'person:select',
            (
                person, // Event listener for person selection
            ) => this.setParam('user', person.id, true), // Set user parameter with selected person's ID
        );
    }
}

// FILE DOCUMENTED
